{
  "$schema": "http://json-schema.org/draft-06/schema#",
  "$id": "http://example.com/example.json",
  "type": "object",
  "properties": {
    "Name": {
      "type": "string"
    },
    "BIDSVersion": {
      "type": "string"
    },
    "HEDVersion": {
      "anyOf": [
        { "type": "string" },
        {
          "type": "array",
          "items": {
            "type": "string",
            "pattern": "^(?:[a-zA-Z]+:)?(?:[a-zA-Z]+_)?(?:0|[1-9]\\d*)\\.(?:0|[1-9]\\d*)\\.(?:0|[1-9]\\d*)(?:-(?:(?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\\+(?:[0-9a-zA-Z-]+(?:\\.[0-9a-zA-Z-]+)*))?$"
          }
        }
      ]
    },
    "DatasetType": {
      "type": "string",
      "enum": ["raw", "derivative"]
    },
    "License": {
      "type": "string"
    },
    "Authors": {
      "items": {
        "type": "string"
      },
      "type": "array"
    },
    "Acknowledgements": {
      "type": "string"
    },
    "HowToAcknowledge": {
      "type": "string"
    },
    "Funding": {
      "items": {
        "type": "string"
      },
      "type": "array"
    },
    "EthicsApprovals": {
      "items": {
        "type": "string"
      },
      "type": "array"
    },
    "ReferencesAndLinks": {
      "items": {
        "type": "string"
      },
      "type": "array"
    },
    "DatasetDOI": {
      "type": "string"
    },
    "DatasetLinks": {
      "type": "object",
      "properties": {},
      "propertyNames": {
        "type": "string",
        "minLength": 1,
        "pattern": "^[a-zA-Z0-9]*$"
      },
      "additionalProperties": {
        "type": "string",
        "format": "uri-reference"
      }
    },
    "GeneratedBy": {
      "type": "array",
      "minItems": 1,
      "items": {
        "type": "object",
        "properties": {
          "Name": { "type": "string" },
          "Version": { "type": "string" },
          "Description": { "type": "string" },
          "CodeURL": { "type": "string", "format": "uri" },
          "Container": {
            "type": "object",
            "properties": {
              "Type": { "type": "string" },
              "Tag": { "type": "string" },
              "URI": { "type": "string", "format": "uri" }
            }
          }
        }
      }
    },
    "SourceDatasets": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "URL": { "type": "string", "format": "uri" },
          "DOI": { "type": "string" },
          "Version": { "type": "string" }
        }
      }
    },
    "Genetics": {
      "type": "object",
      "properties": {
        "Database": {
          "type": "string",
          "format": "uri"
        },
        "Dataset": {
          "type": "string",
          "format": "uri"
        },
        "Descriptors": {
          "items": {
            "type": "string"
          },
          "type": ["array", "string"]
        }
      }
    }
  },
  "required": ["Name", "BIDSVersion"],
  "allOf": [
    {
      "$ref": "#/dependency-definitions/if-DatasetType-is-derivative-then-GeneratedBy-is-required"
    }
  ],
  "dependency-definitions": {
    "if-DatasetType-is-derivative-then-GeneratedBy-is-required": {
      "if": {
        "type": "object",
        "properties": { "DatasetType": { "const": "derivative" } },
        "required": ["DatasetType"]
      },
      "then": {
        "required": ["GeneratedBy"]
      }
    }
  }
}
